import React, { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useColourMode } from "../contexts/ColourContext";

// Define your three theme options
const themeOptions = ["Dark", "Light", "System"];

const ThemeToggle = () => {
  const { themeMode, handleToggleTheme, accentColour } = useColourMode();
  const [selectedTheme, setSelectedTheme] = useState(themeMode);
  const colourTheme = useTheme();

  // Sync selectedTheme with context value when it changes
  useEffect(() => {
    setSelectedTheme(themeMode);

    // Update scrollbar track color based on theme
    const scrollbarTrackColor = colourTheme.palette.background.default;
    document.documentElement.style.setProperty(
      "--scrollbar-track-bg",
      scrollbarTrackColor
    );
  }, [themeMode, colourTheme]);

  // Handle theme selection
  const handleThemeSelect = (index) => {
    const theme = themeOptions[index].toLowerCase(); // Convert to lower case to match the themeMode format
    setSelectedTheme(theme); // Update local state
    handleToggleTheme(theme); // Trigger context to update the global theme
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        backgroundColor: `${colourTheme.palette.background.default}`,
        boxShadow: "inset 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5)",
        borderRadius: "0.5rem",
        padding: "0.25rem",
        position: "relative",
        userSelect: "none",
        mt: 2,
        mb: 1,
      }}
    >
      {/* Render the theme options */}
      {themeOptions.map((theme, index) => (
        <Box
          key={index}
          onClick={() => handleThemeSelect(index)} // Handle click
          sx={{
            flex: 1,
            textAlign: "center",
            zIndex: 1,
            cursor: "pointer",
            fontSize: "0.85rem",
            padding: "0.25rem",
            color:
              selectedTheme.toLowerCase() === theme.toLowerCase()
                ? "#fff"
                : colourTheme.palette.text.primary,
            fontWeight:
              selectedTheme.toLowerCase() === theme.toLowerCase()
                ? "bold"
                : "normal",
            backgroundColor:
              selectedTheme.toLowerCase() === theme.toLowerCase()
                ? accentColour
                : "transparent",
            borderRadius:
              selectedTheme.toLowerCase() === theme.toLowerCase()
                ? "0.25rem"
                : "0",
            boxShadow:
              selectedTheme.toLowerCase() === theme.toLowerCase()
                ? "0 0.125rem 0.25rem rgba(0, 0, 0, 0.5)"
                : "none",
          }}
        >
          <p style={{ marginTop: 0, marginBottom: 0 }}>{theme}</p>
        </Box>
      ))}
    </Box>
  );
};

export default ThemeToggle;
